import * as types from './actionTypes'
import * as api from '../../../../common/api'

export const fetchInvoiceList = customerId => ({
    types: [types.FETCH_INVOICE_REQUEST, types.FETCH_INVOICE_SUCCESS, types.FETCH_INVOICE_FAILURE],
    apiCall: () => api.getInvoices(customerId)
});

// export const fetchAvailableInvocePdfs = customerId => ({
//     types: [types.FETCH_INVOICE_AVAILABLE_PDF_REQUEST, types.FETCH_INVOICE_AVAILABLE_PDF_SUCCESS, types.FETCH_INVOICE_AVAILABLE_PDF_FAILURE],
//     apiCall: () => api.getAvailableInvocePdfs(customerId)
// });

export const fetchInvocePdf = (customerId, invoiceId) => ({
    types: [types.FETCH_INVOICE_PDF_REQUEST, types.FETCH_INVOICE_PDF_SUCCESS, types.FETCH_INVOICE_PDF_FAILURE],
    apiCall: () => api.getInvocePdf(customerId, invoiceId)
});

export const fetchFinancialBalance = customerId => ({
    types: [types.FETCH_BALANCE_REQUEST, types.FETCH_BALANCE_SUCCESS, types.FETCH_BALANCE_FAILURE],
    apiCall: () => api.getFinancialBalance(customerId)
});
